import React, { Component } from "react";
import { connect } from "react-redux";
import StoreNav from "./store-nav.component";
import StoreService from "../services/store.service";
import ProductLabels from "./store-product-labels.component";
import { getUserGroup, isGreenTheme, showsLabels } from "../helpers/experiment";

class StoreLanding extends Component {
  constructor(props) {
    super(props);
    this.currentUser = props.user;
    this.state = {
      products: [],
      basketCount: 0,
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    StoreService.getProducts()
      .then((response) => {
        this.setState({ products: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });

    StoreService.getBasket(this.currentUser.username)
      .then((response) => {
        const count = response.data.reduce((sum, item) => sum + item.quantity, 0);
        this.setState({ basketCount: count });
      })
      .catch(() => {});
  }

  handleProductClick(product) {
    StoreService.logAction(this.currentUser.username, `store-click-product-${product.id}`);
    this.props.history.push(`/store/product/${product.id}`);
  }

  render() {
    const { products, basketCount, loading, error } = this.state;
    const group = getUserGroup();

    return (
      <div id="store-page" className={isGreenTheme(group) ? "store-theme-green" : undefined}>
        <StoreNav basketCount={basketCount} showBack={false} />
        <div className="store-content">
          {loading && <div className="store-loading">Loading...</div>}
          {error && <div className="alert alert-danger" role="alert">{error}</div>}
          {!loading && !error && (
            <div className="store-grid">
              {products.map((product) => (
                <div
                  key={product.id}
                  className="store-product-card"
                  onClick={() => this.handleProductClick(product)}
                >
                  <div className="store-product-image-wrap">
                    <img
                      className="store-product-image"
                      src={`/${product.imageFilename}`}
                      alt={product.name}
                    />
                    {product.labelInfo && showsLabels(group) && (
                      <ProductLabels labelInfo={product.labelInfo} compact={true} />
                    )}
                  </div>
                  <div className="store-product-name">{product.name}</div>
                  <div className="store-product-price">£{product.price.toFixed(2)}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.auth;
  return {
    user,
  };
}

export default connect(mapStateToProps)(StoreLanding);
